import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import ICredDefense from '../interface/prefraud/cred-defense/ICredDefense';

enum FraudServiceEnum {
  reprocessPreFraud = "/reprocess-pre-fraud",
  reprocessFraud = "/reprocess-fraud",
  SendFraudManualAnalysisEmail = "/send-fraud-manual-analysis-email"
}
export default class FraudService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/fraud");
  }

  public reprocessPreFraud = async (tradeId: number, changePhase: boolean): Promise<ICredDefense> => await this.POST(FraudServiceEnum.reprocessPreFraud, { tradeId, changePhase });
  public reprocessFraud = async (tradeId: number, changePhase: boolean) => await this.POST(FraudServiceEnum.reprocessFraud, { tradeId, changePhase });
  public sendFraudManualAnalysisEmail = async (tradeId: number) => await this.POST(FraudServiceEnum.SendFraudManualAnalysisEmail, { tradeId });
}
